import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getPaymentMethodByKey } from "../../../constants/messages/paymentMethods.js";
import { paypalApi } from "../../paypal/api/paypalApi.js";
import { checkoutApi } from "../api/checkoutApi.js";

const initialState = {
  order: {},
  paymentMethod: {},
  errors: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
};

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    updateOrderData: (state, { payload }) => {
      state.order = {
        ...state.order,
        ...payload,
      };
    },
    updatePaymentMethod: (state, { payload }) => {
      state.paymentMethod = getPaymentMethodByKey("fundingSource", payload);
    },
    resetCheckout: (state, _action) => {
      Object.assign(state, initialState);
    },
    updateErrors: (state, action) => {
      const { payload } = action;
      state.errors = {
        ...state.errors,
        ...payload,
      };
    },
  },
  extraReducers: (builder) => {
    const { createPendingOrder, checkout } = checkoutApi.endpoints;
    const { createPayPalOrder, capturePayPalPayment } = paypalApi.endpoints;

    builder
      .addMatcher(
        isAnyOf(
          createPendingOrder.matchPending,
          checkout.matchPending,
          createPayPalOrder.matchPending,
          capturePayPalPayment.matchPending,
        ),
        (state, _action) => {
          state.isLoading = true;
          state.isError = false;
        },
      )
      .addMatcher(checkout.matchFulfilled, (state, _action) => {
        state.isError = false;
        state.isLoading = false;
      })
      .addMatcher(
        isAnyOf(
          createPendingOrder.matchRejected,
          checkout.matchRejected,
          createPayPalOrder.matchRejected,
          capturePayPalPayment.matchRejected,
        ),
        (state, _action) => {
          state.isError = true;
          state.isLoading = false;
        },
      )
      .addMatcher(checkout.matchFulfilled, (state, { payload }) => {
        state.order = {
          ...state.order,
          orderId: payload.order_id,
        };
        state.isSuccess = true;
      });
  },
});
export const {
  updateOrderData,
  updatePaymentMethod,
  resetCheckout,
  updateErrors,
} = checkoutSlice.actions;

export const getCheckout = (state) => state.checkout;
export const getPaymentMethod = (state) => state.checkout.data.paymentMethod;
export const getErrors = (key) => (state) =>
  key ? state.errors[key] : state.errors;

export default checkoutSlice.reducer;
